export const BookingTypesPage = {
  en: {
    'Book training': 'Book training',
    'Sign up for class': 'Sign up for class',
    'Register for event': 'Register for event',
    'Payment maintenance warning title': 'Attention!',
    'Payment maintenance warning message':
      'Technical work is underway. Online purchase is temporarily unavailable. Please contact the administrator.',
  },
  uk: {
    'Book training': 'Забронювати тренування',
    'Sign up for class': 'Записатись на клас',
    'Register for event': 'Зареєструватись на подію',
    'Payment maintenance warning title': 'Увага!',
    'Payment maintenance warning message':
      'Проводяться технічні роботи. Онлайн купівля тимчасово не працює. Зверніться, будь ласка, до адміністратора.',
  },
};
